import { useGetInline } from "@rentiohq/shared-frontend/dist/hooks/api.hooks";
import * as authHooks from "@rentiohq/shared-frontend/dist/redux/auth/auth.hooks";
import { getName } from "@rentiohq/shared-frontend/dist/redux/contact/contact.utils";
import { EAccountRole } from "@rentiohq/shared-frontend/dist/types/auth.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import {
  Loading,
  ResourceList,
  ResourceListItem,
} from "@rentiohq/web-shared/dist/components";
import { ChangeRoleModal } from "components/ChangeRoleModal";
import { IEnabledAccount } from "components/EnabledAccountsSelect/EnabledAccountsSelect";
import React from "react";

export const Employees = () => {
  const { broker } = authHooks.useSelf();
  const isOfficeAdmin = authHooks.useIsOfficeAdmin();

  const [selectedEmployee, setSelectedEmployee] = React.useState<
    IEnabledAccount | undefined
  >(undefined);

  const { data, isFetching, fetchData } = useGetInline<IEnabledAccount[]>({
    path: broker ? `/brokers/${broker.id}/employee-accounts` : undefined,
  });

  const getRoleLabel = (roles?: EAccountRole[]) =>
    roles?.includes(EAccountRole.OfficeAdmin)
      ? getLocalizedText("account_role.office_admin")
      : getLocalizedText("account_role.employee");

  // render
  const renderItem = (item: IEnabledAccount) => (
    <ResourceListItem
      item={item}
      actions={
        isOfficeAdmin
          ? [
              {
                content: getLocalizedText("account_role.action.change_role"),
                onClick: () => setSelectedEmployee(item),
              },
            ]
          : []
      }
    >
      <div>{getName(item)}</div>
      <div>{getRoleLabel(item.accountRoles)}</div>
    </ResourceListItem>
  );

  if (isFetching && !data) {
    return <Loading />;
  }

  return (
    <>
      <ResourceList items={data || []} renderItem={renderItem} />

      {selectedEmployee && (
        <ChangeRoleModal
          employee={selectedEmployee}
          onClose={() => setSelectedEmployee(undefined)}
          onSuccess={() => {
            setSelectedEmployee(undefined);
            fetchData(false);
          }}
        />
      )}
    </>
  );
};

// eslint-disable-next-line import/no-default-export
export default Employees;
